import { RolesApi } from "@/Administration/Api/Roles/RolesApi";
import { AdministrationHelper } from "@/Administration/Helpers/AdministrationHelper";
import { ImportClickableTextEnum } from "@/Administration/Models/UI/ClickableTexts/ImportClickableTextEnum";
import { LanguageOptions } from "@/Administration/Models/UI/Enums/Administration";
import { IServiceComboGridModel } from "@/Administration/Models/UI/ServiceCombo/IServiceComboGridModel";
import { IUsersTabModel } from "@/Administration/Models/UI/Users/IUsersTabModel";
import { UserEditMode } from "@/Administration/Models/UI/Users/UserEditMode";
import { UsersSubmenuEnum } from "@/Administration/Models/UI/Users/UsersSubmenuEnum";
import { AdministrationStore } from "@/Administration/Stores/AdministrationStore";
import { ClickableTextItem } from "@/Common/Api/ClickableText/Dto/ClickableTextItem";
import { Service } from "@/Common/Api/Services/Dto/Responses/Service";
import { EmployeeType } from "@/Common/Models/Employee/Enums/EmployeeType";
import { IReferralDoctorModel } from "@/Common/Models/IReferralDoctorModel";
import { TitleAndSpecialtyModel } from "@/Common/Models/MedfarDictionaries/TitleAndSpecialtyModel";
import { Person } from "@/Common/Models/Person/Person";
import { IComboOrServiceItem } from "@/Common/Models/Services/BaseServiceDefinitionModel";
import { ServiceModel } from "@/Common/Models/Services/ServiceModel";
import { ServiceOrComboTableItem } from "@/Common/Models/Services/ServiceOrComboTableItem";
import { EmployeeUIModel } from "@/Common/Models/UI/Employee/EmployeeUIModel";
import { ProfilePicture } from "@/Common/Models/UI/ProfilePicture";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { BaseOperationHandler } from "@/Common/Stores/Handlers/Local/BaseOperationHandler";

class AdministrationUsersHandler extends BaseOperationHandler {
    constructor() {
        super();
        this.RegisterOperation(LocalOperations.AdministrationUsers.ToggleUserSearchSideBar, this.toggleUserSearchSideBar);
        this.RegisterOperation(LocalOperations.AdministrationUsers.GetAllEmployeeSearch, this.getAllEmployeeSearch);
        this.RegisterOperation(LocalOperations.AdministrationUsers.HideInactiveUsers, this.hideInactiveUsers);
        this.RegisterOperation(LocalOperations.AdministrationUsers.InActivateUsers, this.changeActivationUsers);
        this.RegisterOperation(LocalOperations.AdministrationUsers.SubmenuClick, this.changeSubmenuTab);
        this.RegisterOperation(LocalOperations.AdministrationUsers.ReinitUsersPopupOpen, this.reinitUsersPopupOpen);
        this.RegisterOperation(LocalOperations.AdministrationUsers.ReinitUsersPopupClose, this.reinitUsersPopupClose);
        this.RegisterOperation(LocalOperations.AdministrationUsers.GetEmployeeInfo, this.getEmployeeInfo);
        this.RegisterOperation(LocalOperations.AdministrationUsers.ProfilePictureUploaded, this.saveProfilePicture);
        this.RegisterOperation(LocalOperations.AdministrationUsers.ShowCreateEmployeePopup, this.showCreateEmployeePopup);
        this.RegisterOperation(LocalOperations.AdministrationUsers.CloseCreateEmployeePopup, this.closeCreateEmployeePopup);
        this.RegisterOperation(LocalOperations.AdministrationUsers.CreateClericalEmployee, this.createClericalAccount);
        this.RegisterOperation(LocalOperations.AdministrationUsers.CreateClinicalEmployee, this.createClinicalAccount);
        this.RegisterOperation(LocalOperations.AdministrationUsers.EditUser, this.editUser);
        this.RegisterOperation(LocalOperations.AdministrationUsers.CancelEditUser, this.cancelEditUser);
        this.RegisterOperation(LocalOperations.AdministrationUsers.EditUserNextSection, this.editUserNext);
        this.RegisterOperation(LocalOperations.AdministrationUsers.EditUserPreviousSection, this.editUserPrevious);
        this.RegisterOperation(LocalOperations.AdministrationUsers.SaveUser, this.saveUser);
        this.RegisterOperation(LocalOperations.AdministrationUsers.OrphanLabsClinicianChange, this.orphanLabsClinicianChange);
        this.RegisterOperation(LocalOperations.AdministrationUsers.OrphanLabsFromChange, this.orphanLabsFromChange);
        this.RegisterOperation(LocalOperations.AdministrationUsers.OrphanLabsToChange, this.orphanLabsToChange);
        this.RegisterOperation(LocalOperations.AdministrationUsers.AddClinicianToOrphanLabsList, this.addClinicianToOrphanLabsList);
        this.RegisterOperation(LocalOperations.AdministrationUsers.RemoveClinicianFromOrphanLabsList, this.removeClinicianFromOrphanLabsList);
        this.RegisterOperation(LocalOperations.AdministrationUsers.ChangeTagSelection, this.changeTagSelection);
        this.RegisterOperation(LocalOperations.AdministrationUsers.AddNewUsefulLink, this.addNewUsefulLink);
        this.RegisterOperation(LocalOperations.AdministrationUsers.AddUserServiceComboPopupClose, this.closeAddServiceCombo);
        this.RegisterOperation(LocalOperations.AdministrationUsers.SaveNewServicesCombo, this.addNewServicesComboToEditedEmployee);
        this.RegisterOperation(LocalOperations.AdministrationUsers.OpenAddServiceCombo, this.openAddServiceCombo);
        this.RegisterOperation(LocalOperations.AdministrationUsers.SearchSettings_Open, this.openSearchSettings);
        this.RegisterOperation(LocalOperations.AdministrationUsers.SearchSettings_Close, this.closeSearchSettings);
        this.RegisterOperation(LocalOperations.AdministrationUsers.RefreshServices, this.refreshServices);
        this.RegisterOperation(LocalOperations.AdministrationUsers.CloseRefreshClickableText, this.closeRefreshClickableText);
        this.RegisterOperation(LocalOperations.AdministrationUsers.OpenModifyUserTypePopup, this.openModifyUserTypePopup);
        this.RegisterOperation(LocalOperations.AdministrationUsers.CloseModifyUserTypePopup, this.closeModifyUserTypePopup);
        this.RegisterOperation(LocalOperations.AdministrationUsers.PhoneModify, this.modifyPhone);
        this.RegisterOperation(LocalOperations.AdministrationUsers.EmailModify, this.modifyEmail);
        this.RegisterOperation(LocalOperations.AdministrationUsers.UserNameModify, this.modifyUserName);
        this.RegisterOperation(LocalOperations.AdministrationUsers.PasswordModify, this.modifyPassword);
        this.RegisterOperation(LocalOperations.AdministrationUsers.UserTypeModify, this.userTypeModify);
        this.RegisterOperation(LocalOperations.AdministrationUsers.ShowLoadClickableTextFromAnotherUsers, this.showLoadClickableTextFromAnotherUsers);
        this.RegisterOperation(LocalOperations.AdministrationUsers.LoadClickableTextFromAnotherUser, this.getClickableTextFromAnotherUsers);
        this.RegisterOperation(LocalOperations.AdministrationUsers.IsCreateClickableTextOpen, this.createClickableTextOpen);
        this.RegisterOperation(LocalOperations.AdministrationUsers.MutateEmployeeUIModel, this.mutateEmployeeUIModel);
        this.RegisterOperation(LocalOperations.AdministrationUsers.ProfilePictureDeleted, this.deleteProfilePic);
        this.RegisterOperation(LocalOperations.AdministrationUsers.PinModify, this.modifyPin);
        this.RegisterOperation(LocalOperations.AdministrationUsers.CloseModifyPinPopup, this.closeModifyPinPopup);
        this.RegisterOperation(LocalOperations.AdministrationUsers.setTextSearch, this.setTextSearch);
        this.RegisterOperation(LocalOperations.AdministrationUsers.DeleteClickableTextSection, this.deleteClickableTextSection);
        this.RegisterOperation(LocalOperations.AdministrationUsers.OpenImportClickableText, this.openImportClickabletext);
        this.RegisterOperation(LocalOperations.AdministrationUsers.CloseClickableTextImport, this.closeClickableTextImport);
        this.RegisterOperation(LocalOperations.AdministrationUsers.SetActivatedTabImportClickabeText, this.setActivatedTabImportClickabeText);
        this.RegisterOperation(LocalOperations.AdministrationUsers.SelectDetailsOfClickableText, this.selectDetailsOfClickableText);
        this.RegisterOperation(LocalOperations.AdministrationUsers.SaveClickableTextImport, this.saveClickableTextImport);
        this.RegisterOperation(LocalOperations.AdministrationUsers.GetAllClickableTectFromSpecificUserForSpecificContext, this.getAllClickableTextFromSpecificUserForSpecificContext);

        this.RegisterOperation(LocalOperations.AdministrationUsers.CleanDetailsOfClickableText, this.cleanDetailsOfClickableText);
        this.RegisterOperation(LocalOperations.AdministrationUsers.OnChangeLanguageForClickableText, this.changeLanguageForClickableText);
        this.RegisterOperation(LocalOperations.AdministrationUsers.ResendEmailVerificationCode, this.resendEmailVerificationCode);
    }

    private toggleUserSearchSideBar(): void {
        let isMenuOpen = administrationStore.usersTabModel.get("SearchMenuOpen");
        administrationStore.usersTabModel = administrationStore.usersTabModel.set("SearchMenuOpen", !isMenuOpen);
    }

    private getAllEmployeeSearch(request: LocalEvent, store: AdministrationStore): void {
        store.usersActions.getSearchAllEmployee();
    }

    private hideInactiveUsers(request: LocalEvent, store: AdministrationStore): void {
        let isHideInactiveUsers = store.usersTabModel.get("UsersSearchModel").get("HideInactiveUsers");
        let usersSearchModel = store.usersTabModel.get("UsersSearchModel");
        usersSearchModel = usersSearchModel.set("HideInactiveUsers", !isHideInactiveUsers);
        store.usersTabModel = store.usersTabModel.set("UsersSearchModel", usersSearchModel);
    }

    private changeActivationUsers(request: LocalEvent, store: AdministrationStore): void {
        let isActive = request.Get<boolean>("IsInActive");
        let contactId = request.Get<string>("contactId");
        store.usersActions.changeActivationUsers(contactId, isActive);
    }

    private reinitUsersPopupOpen(request: LocalEvent, store: AdministrationStore): void {
        let employeeId = request.Get<string>("EmployeeId");

        let usersSearchModel = store.usersTabModel.get("UsersSearchModel");
        usersSearchModel = usersSearchModel.set("ReinitPopupOpen", true);
        usersSearchModel = usersSearchModel.set("SelectedEmployeeId", employeeId);
        store.usersTabModel = store.usersTabModel.set("UsersSearchModel", usersSearchModel);
    }

    private reinitUsersPopupClose(request: LocalEvent, store: AdministrationStore): void {
        let usersSearchModel = store.usersTabModel.get("UsersSearchModel");
        usersSearchModel = usersSearchModel.set("ReinitPopupOpen", false);
        store.usersTabModel = store.usersTabModel.set("UsersSearchModel", usersSearchModel);
    }

    private getEmployeeInfo(request: LocalEvent, store: AdministrationStore): void {
        store.usersTabModel = store.usersTabModel.set("ClickableTextSpecificUser", null);
        let employeeId = request.Get<string>("EmployeeId");

        store.usersTabModel = this.ClearCurrentEmployeeSelection(store.usersTabModel);

        store.usersActions.getEmployeeInfo(employeeId);

        store.usersTabModel = store.usersTabModel.set("SelectedSubmenuItem", UsersSubmenuEnum.Demography);
        store.usersTabModel = store.usersTabModel.set("UserEditMode", UserEditMode.View);
    }

    private ClearCurrentEmployeeSelection(usersTabModel: IUsersTabModel): IUsersTabModel {
        usersTabModel = usersTabModel.set("SelectedEmployee", null);
        usersTabModel = usersTabModel.set("EditedUser", null);
        usersTabModel = usersTabModel.set("IsCreateClickableTextOpen", false);
        usersTabModel = usersTabModel.set("ClickableTextSpecificUser", null);
        usersTabModel = usersTabModel.set("NewUsefulLink", null);
        return usersTabModel;
    }

    private changeSubmenuTab(request: LocalEvent, store: AdministrationStore): void {
        let selectedTab = request.Get<UsersSubmenuEnum>("selectedTab");
        store.usersTabModel = store.usersTabModel.set("SelectedSubmenuItem", selectedTab);
        if (selectedTab !== UsersSubmenuEnum.Demography) {
            store.usersTabModel = store.usersTabModel
                .set("IsModifyPhoneMode", false)
                .set("IsModifyEmailMode", false);
        }
    }

    private saveProfilePicture(request: LocalEvent, store: AdministrationStore): void {
        let path = request.Get<string>("path");
        let contactId = request.Get<string>("employeeContactId");
        store.usersActions.saveProfilePic(path, contactId);
    }

    private showCreateEmployeePopup(request: LocalEvent, store: AdministrationStore): void {
        let usersModel = store.usersTabModel.set("CreatePopupOpen", true);
        store.usersTabModel = usersModel;
    }

    private closeCreateEmployeePopup(request: LocalEvent, store: AdministrationStore): void {
        let usersModel = store.usersTabModel.set("CreatePopupOpen", false);
        store.usersTabModel = usersModel;
    }

    private createClinicalAccount(request: LocalEvent, store: AdministrationStore): void {
        store.usersTabModel = store.usersTabModel.set("ClickableTextSpecificUser", null);
        store.usersTabModel = store.usersTabModel.set("SelectePDFTagIds", null);
        store.usersTabModel = store.usersTabModel.set("EditedUser", null);
        let licencedIntervenorInfo = request.Get<IReferralDoctorModel>("licencedIntervenorInfo");
        const titleAndSpecialty = request.Get<TitleAndSpecialtyModel>("speciality");
        this.setUICreationMode(EmployeeType.Practician, licencedIntervenorInfo, titleAndSpecialty, store);
        this.closeCreateEmployeePopup(request, store);
    }

    private createClericalAccount(request: LocalEvent, store: AdministrationStore): void {
        store.usersTabModel = store.usersTabModel.set("ClickableTextSpecificUser", null);
        store.usersTabModel = store.usersTabModel.set("SelectePDFTagIds", null);
        store.usersTabModel = store.usersTabModel.set("EditedUser", null);
        const titleAndSpecialty = request.Get<TitleAndSpecialtyModel>("speciality");
        let licencedIntervenorInfo = request.Get<IReferralDoctorModel>("licencedIntervenorInfo");
        this.setUICreationMode(EmployeeType.Assistant, licencedIntervenorInfo, titleAndSpecialty, store);
        this.closeCreateEmployeePopup(request, store);
    }

    private setUICreationMode(userType: EmployeeType, intervenorInfo: IReferralDoctorModel, titleAndSpecialty: TitleAndSpecialtyModel, store: AdministrationStore): void {
        const newUser = intervenorInfo == null
            ? EmployeeUIModel.new()
            : EmployeeUIModel.fromIntervenorInfo(intervenorInfo, titleAndSpecialty);

        newUser.Model.Type = userType;

        store.usersTabModel = store.usersTabModel
            .set("UserEditMode", UserEditMode.Create)
            .set("UserType", userType)
            .set("SelectedSubmenuItem", UsersSubmenuEnum.Demography)
            .set("SelectedEmployee", newUser.clone())
            .set("EditedUser", newUser.clone());
    }

    private editUser(request: LocalEvent, store: AdministrationStore): void {
        let usersModel = store.usersTabModel;

        usersModel = usersModel.set("UserEditMode", UserEditMode.Edit);
        usersModel = usersModel.set("UserType", usersModel.get("SelectedEmployee").Type);

        usersModel = usersModel.set("EditedUser", usersModel.get("SelectedEmployee").clone());
        usersModel = usersModel.set("ClickableTextSpecificUser", null);
        store.usersTabModel = usersModel;
    }

    private cancelEditUser(request: LocalEvent, store: AdministrationStore): void {
        let usersModel = store.usersTabModel;

        if (usersModel.get("UserEditMode") == UserEditMode.Create)
            usersModel = usersModel.set("SelectedEmployee", null);
        usersModel = usersModel.set("UserEditMode", UserEditMode.View);
        usersModel = usersModel.set("EditedUser", null);
        usersModel = usersModel.set("showClickableTextFromAnotherUser", false);
        usersModel = usersModel.set("IsModifyUserNameMode", false);
        usersModel = usersModel.set("IsModifyUserTypeMode", false);
        usersModel = usersModel.set("IsModifyPasswordMode", false);
        usersModel = usersModel.set("IsModifyEmailMode", false);
        usersModel = usersModel.set("IsModifyPhoneMode", false);
        usersModel = usersModel.set("ClickableTextSpecificUser", null);
        usersModel = usersModel.set("ClinicianDateFromOrphanLabs", null);
        usersModel = usersModel.set("ClinicianDateToOrphanLabs", null);
        store.usersTabModel = store.usersTabModel.set("NewUsefulLink", null);

        store.usersTabModel = usersModel;
    }

    private editUserNext(request: LocalEvent, store: AdministrationStore): void {
        let selectedSubMenu = store.usersTabModel.get("SelectedSubmenuItem");
        let employee = store.usersTabModel.get("EditedUser");

        if (selectedSubMenu != null && selectedSubMenu != UsersSubmenuEnum.Tools) {
            if ((employee.Type !== EmployeeType.Practician) && selectedSubMenu == UsersSubmenuEnum.Configuration)
                store.usersTabModel = store.usersTabModel.set("SelectedSubmenuItem", selectedSubMenu + 2);
            else
                store.usersTabModel = store.usersTabModel.set("SelectedSubmenuItem", selectedSubMenu + 1);
        }
    }

    private editUserPrevious(request: LocalEvent, store: AdministrationStore): void {
        let employee = store.usersTabModel.get("EditedUser");
        let selectedSubMenu = store.usersTabModel.get("SelectedSubmenuItem");
        if (selectedSubMenu != null && selectedSubMenu != UsersSubmenuEnum.Demography) {
            if ((employee.Type !== EmployeeType.Practician) && selectedSubMenu == UsersSubmenuEnum.Tools)
                store.usersTabModel = store.usersTabModel.set("SelectedSubmenuItem", selectedSubMenu - 2);
            else
                store.usersTabModel = store.usersTabModel.set("SelectedSubmenuItem", selectedSubMenu - 1);
        }
    }

    private saveUser(request: LocalEvent, store: AdministrationStore): void {
        const onError = request.Get<() => void>("onError");
        let usersModel = store.usersTabModel;
        let employee = usersModel.get("EditedUser");

        if (employee && this.hasUnsavedOrphanLabsInfo(usersModel, employee)) {
            this.triggerSaveOrphanLabsClinicianAction(
                employee.Model.Contact_id,
                store,
                isSuccess => {
                    if (isSuccess)
                        this.triggerSaveUserAction(store);
                }
            );
        }
        else {
            this.triggerSaveUserAction(store, onError);
        }
    }

    private hasUnsavedOrphanLabsInfo(usersModel: IUsersTabModel, employee: EmployeeUIModel): boolean {
        if (IsNullOrWhiteSpace(usersModel.get("ClinicianIdForOrphanLabs")))
            return false;

        if (employee.Model && employee.Model.OrphanLabForwardDTOs) {
            let isSelectedClinicianAlreadyAdded = employee.Model.OrphanLabForwardDTOs.filter(c => c.ForwardedToName.trim() == usersModel.get("ClinicianNameForOrphanLabs").trim()).length > 0;
            if (isSelectedClinicianAlreadyAdded)
                return false;
        }

        let fromDate = usersModel.get("ClinicianDateFromOrphanLabs");
        let toDate = usersModel.get("ClinicianDateToOrphanLabs");

        if (fromDate != null && toDate != null)
            return fromDate <= toDate;

        return true;
    }

    private triggerSaveUserAction(store: AdministrationStore, onError?: () => void): void {
        let usersModel = store.usersTabModel;
        let employee = usersModel.get("EditedUser");
        let newUsefulLink = usersModel.get("NewUsefulLink");

        if (newUsefulLink != null && newUsefulLink.length > 0) {
            employee.addNewLink(newUsefulLink);
        }

        let canSave = !IsNullOrWhiteSpace(employee.Model.FirstName) && !IsNullOrWhiteSpace(employee.Model.LastName);

        switch (employee.Model.Type) {
            case EmployeeType.Assistant:
            case EmployeeType.Api:
                break;

            // a Practician (Clinical) user must have an issuing organization
            case EmployeeType.Practician:
                canSave &&= !!employee.getIssuingOrgRule();
                break;

            default:
                canSave = false;
                break;
        }

        if (cacheStore.ClinicSettings.EnableRoleBasedAccessControl && employee.Model.Roles?.length)
            RolesApi.ClearRoleHeadersCache();

        if (canSave) {
            employee.Model.ServicesIDsOffered = employee.Model.ServicesOffered ? employee.Model.ServicesOffered.map((service: ServiceModel) => {
                const newService = new Service();
                newService.IsInactive = false;
                newService.EmployeeId = employee.ContactFacetId;
                newService.DefId = service.ServiceDefinitionModel.Model.Id;
                if (!!service.ServiceID) {
                    newService.Id = service.ServiceID;
                }
                return newService;
            }) : [];

            store.usersActions.upsertEmployee(employee.Model, usersModel.get("UserEditMode"), onError);
        }
        else {
            usersModel = usersModel.set("UserEditMode", UserEditMode.Edit);
        }
        usersModel = usersModel.set("IsModifyPhoneMode", false);
        usersModel = usersModel.set("IsModifyEmailMode", false);
        usersModel = usersModel.set("IsModifyUserNameMode", false);
        usersModel = usersModel.set("IsModifyPasswordMode", false);
        usersModel = usersModel.set("IsCreateClickableTextOpen", false);
        usersModel = usersModel.set("ClinicianIdForOrphanLabs", "");
        usersModel = usersModel.set("ClinicianNameForOrphanLabs", "");
        usersModel = usersModel.set("ClinicianDateFromOrphanLabs", null);
        usersModel = usersModel.set("ClinicianDateToOrphanLabs", null);

        store.usersTabModel = usersModel;
    }

    private orphanLabsClinicianChange(request: LocalEvent, store: AdministrationStore): void {
        let value = request.Get<string>("value");
        let name = request.Get<string>("name");
        let usersModel = store.usersTabModel;
        usersModel = usersModel.set("ClinicianIdForOrphanLabs", value);
        usersModel = usersModel.set("ClinicianNameForOrphanLabs", name);
        store.usersTabModel = usersModel;
    }

    private orphanLabsFromChange(request: LocalEvent, store: AdministrationStore): void {
        let value = request.Get<Date>("value");
        let usersModel = store.usersTabModel;

        usersModel = usersModel.set("ClinicianDateFromOrphanLabs", value);
        store.usersTabModel = usersModel;
    }

    private orphanLabsToChange(request: LocalEvent, store: AdministrationStore): void {
        let value = request.Get<Date>("value");
        let usersModel = store.usersTabModel;
        usersModel = usersModel.set("ClinicianDateToOrphanLabs", value);
        store.usersTabModel = usersModel;
    }

    private addClinicianToOrphanLabsList(request: LocalEvent, store: AdministrationStore): void {
        let userId = request.Get<string>("UserId");
        this.triggerSaveOrphanLabsClinicianAction(userId, store);
    }

    private triggerSaveOrphanLabsClinicianAction(userId: string, store: AdministrationStore, then?: (isSuccess: boolean) => void): void {
        let usersModel = store.usersTabModel;
        let id = usersModel.get("ClinicianIdForOrphanLabs");
        let fromDate = usersModel.get("ClinicianDateFromOrphanLabs");
        let toDate = usersModel.get("ClinicianDateToOrphanLabs");

        usersModel = usersModel.set("ClinicianIdForOrphanLabs", "");
        usersModel = usersModel.set("ClinicianNameForOrphanLabs", "");
        usersModel = usersModel.set("ClinicianDateFromOrphanLabs", null);
        usersModel = usersModel.set("ClinicianDateToOrphanLabs", null);

        store.usersTabModel = usersModel;

        var labContextIds = cacheStore.GetSitesContextIdsCommaSeparated();
        store.usersActions.saveOrphanLabsClinician(id, labContextIds, fromDate, toDate, userId, then);
    }

    private removeClinicianFromOrphanLabsList(request: LocalEvent, store: AdministrationStore): void {
        let id = request.Get<string>("value");
        let usersModel = store.usersTabModel;
        let list = usersModel.get("EditedUser").Model.OrphanLabForwardDTOs.filter(c => c.ID !== id);
        let employee = usersModel.get("EditedUser");
        employee.Model.OrphanLabForwardDTOs = list;
        usersModel = usersModel.set("EditedUser", employee);
        store.usersTabModel = usersModel;
        store.usersActions.removeOrphanLabClinician(id);
    }

    private changeTagSelection(request: LocalEvent, store: AdministrationStore): void {
        var selection = request.Get<number[]>("value");
        var cache = cacheStore.radPdfTagsCache;
        let employee = store.usersTabModel.get("EditedUser");

        let valuesToUpdate = cache.filter(item => selection.indexOf(item.Key) >= 0);

        let tagIds = valuesToUpdate.map(m => m.Key);
        let tagNames = valuesToUpdate.map(m => m.Value);
        store.usersTabModel = store.usersTabModel.set("PDFSearchKeywords", tagNames.toList());

        let mappedValuesToSend = valuesToUpdate.map(elem => elem.Value);
        store.usersTabModel = store.usersTabModel.set("SelectePDFTagIds", tagIds.toList());
        var mappedValued = mappedValuesToSend.toArray();
        var allowedFormTags: string = "";

        if (store.usersTabModel.get("UserEditMode") == UserEditMode.Create) {
            employee.Model.AllowedFormTags = [];
            allowedFormTags = mappedValued.toString().replaceAll(",", "*");
            employee.Model.AllowedFormTags.push(allowedFormTags);
            store.usersTabModel = store.usersTabModel.set("EditedUser", employee.clone());
        }
        else {
            employee.Model.AllowedFormTags = [];
            allowedFormTags = mappedValued.toString().replaceAll(",", "*");
            employee.Model.AllowedFormTags.push(allowedFormTags);
            store.usersActions.updatePdfTagsForEmployee(mappedValued, employee.Model.Contact_id);
        }
    }

    private addNewUsefulLink(request: LocalEvent, store: AdministrationStore): void {
        var newLink = request.Get<string>("NewLink");
        store.usersTabModel = store.usersTabModel.set("NewUsefulLink", newLink);
    }

    private openAddServiceCombo(request: LocalEvent, store: AdministrationStore): void {
        store.usersTabModel = store.usersTabModel.set("IsOpenAddNewServiceCombo", true);
    }

    private closeAddServiceCombo(request: LocalEvent, store: AdministrationStore): void {
        let selectedServiceDefinitonIds: string[] = request.Get<string[]>("selectedServiceDefinitonIds");
        store.usersTabModel = store.usersTabModel.set("IsOpenAddNewServiceCombo", false);

        // undo changes in edit model
        let editedEmployee = store.usersTabModel.get("EditedUser");

        if (selectedServiceDefinitonIds && selectedServiceDefinitonIds.length > 0) {
            editedEmployee.Model.ServicesOffered = editedEmployee.Model.ServicesOffered.filter(serviceOffered => selectedServiceDefinitonIds.indexOf(serviceOffered.ServiceID) == -1);
        }

        store.usersTabModel.set("EditedUser", editedEmployee);
        sessionStore.hideGlobalOverlay();
    }

    private openSearchSettings(request: LocalEvent, store: AdministrationStore): void {
        let model = store.usersTabModel.get("UserServiceComboGridModel");
        model = model.set("SearchSettingsOpen", !model.get("SearchSettingsOpen"));
        store.usersTabModel = store.usersTabModel.set("UserServiceComboGridModel", model);
    }

    private closeSearchSettings(request: LocalEvent, store: AdministrationStore): void {
        let model = store.usersTabModel.get("UserServiceComboGridModel");
        model = model.set("SearchSettingsOpen", false);
        store.usersTabModel = store.usersTabModel.set("UserServiceComboGridModel", model);
    }

    private refreshServices(request: LocalEvent, store: AdministrationStore): void {
        let closeSettings = request.Get<boolean>("closeSettings");
        let model = request.Get<IServiceComboGridModel>("model");
        let storeModel = store.usersTabModel.get("UserServiceComboGridModel");

        let filteredServices: ServiceOrComboTableItem<IComboOrServiceItem>[] = model == null ? storeModel.get("FilteredCombosAndServices").toArray() :
            AdministrationHelper.FilterAndOrderServiceComboDefinitions(
                cacheStore.ServiceDefinitionCache.toArray(),
                cacheStore.ServiceDefinitionComboCache.toArray(),
                model.get("EmployeesFiltered").toArray(),
                model.get("Sites").toArray(),
                model.get("Types").toArray(),
                model.get("Specializations").toArray(),
                storeModel.get("GridSortColumn"),
                storeModel.get("GridSortDirection"),
                model.get("Status_IsActiveChecked"),
                model.get("Status_IsInactiveChecked"),
                store.serviceComboGridModel.get("ServiceAndComboSearchText")
            );

        if (closeSettings) {
            storeModel = storeModel.set("SearchSettingsOpen", false);
        }
        if (model != null) {
            if (model.get("EmployeesFiltered").size == storeModel.get("EmployeesFiltered").size)
                storeModel = storeModel.set("EmployeesFiltered", model.get("EmployeesFiltered"));

            storeModel = storeModel.set("Sites", model.get("Sites"));
            storeModel = storeModel.set("Types", model.get("Types"));
            storeModel = storeModel.set("Specializations", model.get("Specializations"));
            storeModel = storeModel.set("Status_IsActiveChecked", model.get("Status_IsActiveChecked"));
            storeModel = storeModel.set("Status_IsInactiveChecked", model.get("Status_IsInactiveChecked"));
        }
        storeModel = storeModel.set("FilteredCombosAndServices", Immutable.List(filteredServices));
        store.usersTabModel = store.usersTabModel.set("UserServiceComboGridModel", storeModel);
    }

    private addNewServicesComboToEditedEmployee(request: LocalEvent, store: AdministrationStore): void {
        let editedUser = store.usersTabModel.get("EditedUser");

        if (editedUser.Model.ServicesIDsOffered == null)
            editedUser.Model.ServicesIDsOffered = [];

        if (editedUser.Model.ServicesOffered == null)
            editedUser.Model.ServicesOffered = [];

        editedUser.addNewServices();

        store.usersTabModel.set("EditedUser", editedUser);
        store.usersTabModel = store.usersTabModel.set("IsOpenAddNewServiceCombo", false);
    }

    private closeRefreshClickableText(request: LocalEvent, store: AdministrationStore): void {
        let editEmployee = store.usersTabModel.get("EditedUser");
        let employeeId = editEmployee.Model.ContactFacet_id;
        store.usersTabModel = store.usersTabModel.set("IsRefreshClickableText", true);

        window.setTimeout(() => store.usersActions.getCliackableTextSpecificUser(employeeId), 400);
    }

    private modifyPhone(request: LocalEvent, store: AdministrationStore): void {
        store.usersTabModel = store.usersTabModel.set("IsModifyEmailMode", false);
        store.usersTabModel = store.usersTabModel.set("IsModifyPhoneMode", true);
        let selectedTab = request.Get<UsersSubmenuEnum>("selectedTab");

        if (store.usersTabModel.get("UserEditMode") === UserEditMode.Edit
            && store.usersTabModel.get("SelectedSubmenuItem") === UsersSubmenuEnum.Demography
        )
            return;

        store.usersTabModel = store.usersTabModel.set("SelectedSubmenuItem", selectedTab);
        this.editUser(request, store);
    }

    private modifyEmail(request: LocalEvent, store: AdministrationStore): void {
        store.usersTabModel = store.usersTabModel.set("IsModifyPhoneMode", false);
        store.usersTabModel = store.usersTabModel.set("IsModifyEmailMode", true);
        let selectedTab = request.Get<UsersSubmenuEnum>("selectedTab");

        if (store.usersTabModel.get("UserEditMode") === UserEditMode.Edit
            && store.usersTabModel.get("SelectedSubmenuItem") === UsersSubmenuEnum.Demography
        )
            return;

        store.usersTabModel = store.usersTabModel.set("SelectedSubmenuItem", selectedTab);
        this.editUser(request, store);
    }

    private modifyUserName(request: LocalEvent, store: AdministrationStore): void {
        store.usersTabModel = store.usersTabModel.set("IsModifyUserNameMode", true);
        let selectedTab = request.Get<UsersSubmenuEnum>("selectedTab");
        store.usersTabModel = store.usersTabModel.set("SelectedSubmenuItem", selectedTab);
        this.editUser(request, store);
    }

    private modifyPassword(request: LocalEvent, store: AdministrationStore): void {
        store.usersTabModel = store.usersTabModel.set("IsModifyPasswordMode", true);
        this.reinitUsersPopupOpen(request, store);
    }

    private closeModifyUserTypePopup(request: LocalEvent, store: AdministrationStore): void {
        store.usersTabModel = store.usersTabModel.set("IsModifyUserTypeMode", false);
        sessionStore.hideGlobalOverlay();
    }

    private openModifyUserTypePopup(request: LocalEvent, store: AdministrationStore): void {
        store.usersTabModel = store.usersTabModel.set("IsModifyUserTypeMode", true);
        sessionStore.showGlobalOverlay(true);
    }

    private userTypeModify(request: LocalEvent, store: AdministrationStore): void {
        const employeeId = request.Get<string>("EmployeeId");
        const employeeContactId = request.Get<string>("ContactId");
        const type = request.Get<number>("Type");
        const licenseOrganizationRuleId = request.Get<string>("LicenseOrganizationRuleId");
        const licenseOrganizationSpecializationId = request.Get<string>("LicenseOrganizationSpecializationId");
        store.usersActions.updateUserType(employeeId, type, employeeContactId, licenseOrganizationRuleId, licenseOrganizationSpecializationId);
        sessionStore.hideGlobalOverlay();
    }

    private showLoadClickableTextFromAnotherUsers(request: LocalEvent, store: AdministrationStore): void {
        let IsShowClickableTextAnotherUser: boolean = store.usersTabModel.get("showClickableTextFromAnotherUser");
        store.usersTabModel = store.usersTabModel.set("showClickableTextFromAnotherUser", !IsShowClickableTextAnotherUser);
        store.usersTabModel = store.usersTabModel.set("ClickableTextSpecificUser", null);
    }

    private getClickableTextFromAnotherUsers(request: LocalEvent, store: AdministrationStore): void {
        let employeeid = request.Get<string>("EmployeeId");
        let editedEmployee = store.usersTabModel.get("EditedUser");
        store.usersActions.getCliackableTextSpecificUser(employeeid, false, editedEmployee.Model.Type);
    }

    private createClickableTextOpen(request: LocalEvent, store: AdministrationStore): void {
        store.usersTabModel = store.usersTabModel.set("IsCreateClickableTextOpen", true);
    }

    private mutateEmployeeUIModel(request: LocalEvent, store: AdministrationStore): void {
        let emp = request.Get<EmployeeUIModel>("EditedUser");
        store.usersTabModel = store.usersTabModel.set("EditedUser", emp);
    }

    private deleteProfilePic(request: LocalEvent, store: AdministrationStore): void {
        let profilePicture = request.Get<ProfilePicture>("ProfilePicture");
        store.usersActions.deleteProfilePicEmployee(profilePicture.Id);
    }

    private modifyPin(request: LocalEvent, store: AdministrationStore): void {
        store.usersTabModel = store.usersTabModel.set("IsModifyPinMode", true);
    }

    private closeModifyPinPopup(request: LocalEvent, store: AdministrationStore): void {
        store.usersTabModel = store.usersTabModel.set("IsModifyPinMode", false);
    }

    private setTextSearch(request: LocalEvent, store: AdministrationStore): void {
        let text = request.Get<string>("TextSearch");
        let searchModel = store.usersTabModel.get("UsersSearchModel");
        searchModel = searchModel.set("SearchText", text);
        store.usersTabModel = store.usersTabModel.set("UsersSearchModel", searchModel);
    }

    private deleteClickableTextSection(request: LocalEvent, store: AdministrationStore): void {
        let employeeId = request.Get<string>("EmployeeId");
        let context = request.Get<string>("Context");
        let editedEmployee = store.usersTabModel.get("EditedUser");

        let langClickableText = store.usersTabModel.get("LanguageOptionClickableText");
        let lang = sessionStore.getLanguageStringFromEnum(langClickableText);

        if (store.usersTabModel.get("UserEditMode") == UserEditMode.Edit)
            store.usersActions.deleteClickableTextSection(employeeId, context, lang);
        else {
            if (editedEmployee.Model.TextList && editedEmployee.Model.TextList.length > 0) {
                editedEmployee.Model.TextList = editedEmployee.Model.TextList
                    .filter(x => !(
                        x.Context == context
                        && x.Language == lang
                    ));
            }
            else
                editedEmployee.Model.TextList = [];

            store.usersTabModel = store.usersTabModel.set("EditedUser", editedEmployee.clone());
        }
    }

    private openImportClickabletext(request: LocalEvent, store: AdministrationStore): void {
        let context = request.Get<string>("Context");
        let tab = request.Get<ImportClickableTextEnum>("Tab");
        let editedEmployee = request.Get<EmployeeUIModel>("EditedUser");
        let langClickableText = store.usersTabModel.get("LanguageOptionClickableText");
        let lang = sessionStore.getLanguageStringFromEnum(langClickableText);
        store.usersTabModel = store.usersTabModel.set("SelectedTabImportClickableText", tab);
        store.usersTabModel = store.usersTabModel.set("ContextForImportClickableText", context);

        store.usersTabModel = store.usersTabModel.set("EmployeeClickableTextItems", editedEmployee.Model.TextList.filter(x => x.Context == context && x.Language == lang));

        store.usersTabModel = store.usersTabModel.set("AllListOfClickableTextDetails", []);

        store.usersActions.getAllClickableTextCategories(context, lang);
    }

    private closeClickableTextImport(request: LocalEvent, store: AdministrationStore): void {
        store.usersTabModel = store.usersTabModel.set("IsImportClickableTextOpen", false);
        store.usersTabModel = store.usersTabModel.set("EmployeeClickableTextItems", []);
        store.usersTabModel = store.usersTabModel.set("AllListOfClickableTextDetailsForSpecificUser", []);
        store.usersTabModel = store.usersTabModel.set("AllListOfClickableTextDetails", []);
    }

    private setActivatedTabImportClickabeText(request: LocalEvent, store: AdministrationStore): void {
        let tab = request.Get<ImportClickableTextEnum>("Tab");
        store.usersTabModel = store.usersTabModel.set("SelectedTabImportClickableText", tab);
        store.usersTabModel = store.usersTabModel.set("AllListOfClickableTextDetailsForSpecificUser", []);
        store.usersTabModel = store.usersTabModel.set("AllListOfClickableTextDetails", []);
    }

    private selectDetailsOfClickableText(request: LocalEvent, store: AdministrationStore): void {
        let tab = request.Get<any>("SelectedItem");
        let context = store.usersTabModel.get("ContextForImportClickableText");
        let langClickableText = store.usersTabModel.get("LanguageOptionClickableText");
        let lang = sessionStore.getLanguageStringFromEnum(langClickableText);
        store.usersActions.getClickableTextDetails(tab.toString(), context, lang);
    }

    private saveClickableTextImport(request: LocalEvent, store: AdministrationStore): void {
        let textListImporting = request.Get<ClickableTextItem[]>("TextList");
        let context = store.usersTabModel.get("ContextForImportClickableText");
        store.usersTabModel = store.usersTabModel.set("SelectedTabImportClickableText", null);
        store.usersTabModel = store.usersTabModel.set("IsImportClickableTextOpen", false);
        store.usersTabModel = store.usersTabModel.set("AllTabNamesClickableTextForSpecificContext", []);
        store.usersTabModel = store.usersTabModel.set("ContextForImportClickableText", "");
        store.usersTabModel = store.usersTabModel.set("AllListOfClickableTextDetailsForSpecificUser", []);

        let langClickableText = store.usersTabModel.get("LanguageOptionClickableText");
        let lang = sessionStore.getLanguageStringFromEnum(langClickableText);

        if (textListImporting != null && textListImporting.length > 0) {
            let tabsName: string[] = [];
            tabsName = this.saveClickableTextForImporting(textListImporting);
            let editedEmployee = store.usersTabModel.get("EditedUser");

            if (store.usersTabModel.get("UserEditMode") == UserEditMode.Edit)
                store.usersActions.importListOfClickableText(textListImporting, editedEmployee.Model.Contact_id, context, tabsName, lang);
            else {
                if (editedEmployee.Model.TextList && editedEmployee.Model.TextList.length > 0) {
                    for (let text of textListImporting) {
                        editedEmployee.Model.TextList = editedEmployee.Model.TextList
                            .filter(x => !(
                                x.TabName == text.TabName
                                && x.Context == text.Context
                                && x.Language == text.Language
                            ));

                        editedEmployee.Model.TextList.push(text);
                    }
                    editedEmployee.Model.TextList.sortByProperty(x => x.TabOrderIndex);
                }
                else {
                    editedEmployee.Model.TextList = [];
                    for (let text of textListImporting)
                        editedEmployee.Model.TextList.push(text);
                }

                store.usersTabModel = store.usersTabModel.set("EditedUser", editedEmployee.clone());
            }
        }
    }

    private saveClickableTextForImporting(textList: ClickableTextItem[]): string[] {
        let tabsName: string[] = [];
        for (let text of textList)
            tabsName.push(text.TabName);

        return tabsName;
    }

    private getAllClickableTextFromSpecificUserForSpecificContext(request: LocalEvent, store: AdministrationStore): void {
        let context = store.usersTabModel.get("ContextForImportClickableText");
        let employee = request.Get<Person>("SelectedItem");
        store.usersTabModel = store.usersTabModel.set("SpecificUserForImportClickableText", employee);
        store.usersTabModel = store.usersTabModel.set("AllListOfClickableTextDetailsForSpecificUser", []);

        let langClickableText = store.usersTabModel.get("LanguageOptionClickableText");
        let lang = sessionStore.getLanguageStringFromEnum(langClickableText);
        store.usersActions.getTabDetailsFromSpecificUser(context, employee.ContactId, lang);
    }

    private cleanDetailsOfClickableText(request: LocalEvent, store: AdministrationStore): void {
        store.usersTabModel = store.usersTabModel.set("AllListOfClickableTextDetails", []);
        store.usersTabModel = store.usersTabModel.set("AllListOfClickableTextDetailsForSpecificUser", []);
        let editedEmployee = store.usersTabModel.get("EditedUser");
        let context = store.usersTabModel.get("ContextForImportClickableText");
        let langClickableText = store.usersTabModel.get("LanguageOptionClickableText");
        let language = sessionStore.getLanguageStringFromEnum(langClickableText);

        store.usersTabModel = store.usersTabModel.set("EmployeeClickableTextItems", editedEmployee.Model.TextList.filter(x => x.Context == context && x.Language == language));
    }

    private changeLanguageForClickableText(request: LocalEvent, store: AdministrationStore): void {
        let lang = request.Get<LanguageOptions>("LanguageOption");
        store.usersTabModel = store.usersTabModel.set("LanguageOptionClickableText", lang);
    }

    private resendEmailVerificationCode(request: LocalEvent, store: AdministrationStore): void {
        store.usersTabModel = store.usersTabModel.set("ResendEmailVerificationCodeInProgress", true);

        let emailAddress = request.Get<string>("emailAddress");
        let contactPointId = request.Get<string>("contactPointId");
        let contactId = request.Get<string>("contactId");
        let contactFacetId = request.Get<string>("contactFacetId");
        let language = request.Get<string>("language");

        store.usersActions.resendEmailVerificationCode(emailAddress, contactPointId, contactId, contactFacetId, language);
    }
}

export { AdministrationUsersHandler };
